import axios from "axios";
import React, { Component } from "react";
import FeatherIcon from "feather-icons-react";
import ReactToPrint from "react-to-print";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Headerpdf from "../../users/Headerpdf";
import Lesson from "../lessons/Lesson";
import SectionclasselessonForm from "./SectionclasselessonFormV2";
import "./sectionclasselesson.css";

const HOURS_PER_DAY = 6;
const numberValue = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};
const bulletinIndex = (lesson) => {
    if (
        lesson?.indice === null ||
        lesson?.indice === undefined ||
        lesson?.indice === ''
    )
        return Number.POSITIVE_INFINITY;

    const parsed = Number(lesson.indice);
    return Number.isFinite(parsed) ? parsed : Number.POSITIVE_INFINITY;
};
const compareLessonsByBulletinOrder = (left, right) => {
    const leftIndex = bulletinIndex(left);
    const rightIndex = bulletinIndex(right);
    if (leftIndex !== rightIndex) return leftIndex - rightIndex;

    return (left.lesson?.entitled_lesson || '').localeCompare(
        right.lesson?.entitled_lesson || '',
        'fr',
        { sensitivity: 'base', numeric: true }
    );
};
const staffName = (staff) => {
    const user = staff?.user || {};
    return [user.last_name, user.family_name, user.first_name]
        .filter(Boolean)
        .join(" ") || "Enseignant non renseigné";
};
const className = (item) =>
    [
        item?.class?.short_entitled_class,
        item?.title,
        item?.section?.short_entitled_section,
    ]
        .filter(Boolean)
        .join(" ");
const availableDayCount = (staff, validDays) =>
    new Set(
        (staff?.daystaffs || [])
            .filter(
                (item) =>
                    Number(item.actif) === 1 &&
                    validDays.has(String(item.dayId))
            )
            .map((item) => String(item.dayId))
    ).size;

class Sectionclasselesson extends Component {
    state = {
        loading: false,
        error: "",
        isModal: false,
        formData: null,
        sectionclasse: null,
        sectionDiplique: null,
        sectionclasseId: "",
        savingDuplicate: false,
        sectionclasses: [],
        allClasses: [],
        staffs: [],
        days: [],
        search: "",
        sectionFilter: "all",
        readinessFilter: "all",
        collapsed: {},
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = async () => {
        this.setState({ loading: false, error: "" });
        try {
            const [assignments, classes, staffs, days] = await Promise.all([
                axios.get("sectionclasselessons"),
                axios.get("sectionclasses"),
                axios.get("staffs"),
                axios.get("days"),
            ]);
            this.setState({
                sectionclasses: assignments.data || [],
                allClasses: classes.data || [],
                staffs: staffs.data || [],
                days: days.data || [],
                loading: true,
            });
        } catch (error) {
            const message =
                error.response?.data?.msg ||
                "Impossible de charger la préparation de l’horaire.";
            this.setState({ loading: true, error: message });
            toast.error(message);
        }
    };

    showModal = (formData = null, sectionclasse = null) => {
        this.setState(
            (state) => ({
                isModal: !state.isModal,
                formData,
                sectionclasse,
            }),
            () => {
                if (!this.state.isModal) this.loadData();
            }
        );
    };

    handleInput = ({ target }) => {
        this.setState({ [target.name]: target.value });
    };

    handleCheck = (permission) => {
        const permissions = localStorage.getItem("permissions")
            ? JSON.parse(localStorage.getItem("permissions"))
            : [];
        return permissions.some((item) => item.permission === permission);
    };

    openDuplicate = (source) => {
        const target = this.state.allClasses.find(
            (item) => String(item.id) !== String(source.id)
        );
        this.setState({
            sectionDiplique: source,
            sectionclasseId: target?.id || "",
        });
    };

    closeDuplicate = () =>
        this.setState({ sectionDiplique: null, sectionclasseId: "" });

    duplicateLessons = async () => {
        const source = this.state.sectionDiplique;
        const targetId = this.state.sectionclasseId;
        if (!targetId) return toast.error("Sélectionnez une classe cible.");
        if (String(targetId) === String(source?.id))
            return toast.error("Choisissez une classe différente.");

        const sourceLessons = source?.sectionclasselessons || [];
        const target = this.state.sectionclasses.find(
            (item) => String(item.id) === String(targetId)
        );
        const existing = new Set(
            (target?.sectionclasselessons || []).map((item) =>
                String(item.lesson?.id)
            )
        );
        const lessons = sourceLessons.filter(
            (item) => !existing.has(String(item.lesson?.id))
        );
        if (!lessons.length)
            return toast.info("Tous ces cours existent déjà dans la classe cible.");

        this.setState({ savingDuplicate: true });
        try {
            await Promise.all(
                lessons.map((item) =>
                    axios.post("sectionclasselessons", {
                        sectionclasseId: targetId,
                        sectionclassId: targetId,
                        lessonId: item.lesson?.id || null,
                        staffId: item.staff?.id || null,
                        max_examen: numberValue(item.max_examen) || null,
                        max_evaluation:
                            numberValue(item.max_evaluation) || null,
                        indice: numberValue(item.indice) || null,
                        domaineId: item.domaineId || item.domaine?.id || null,
                        week_hour: numberValue(item.week_hour),
                        operation: "Ajouter",
                    })
                )
            );
            toast.success(
                `${lessons.length} cours dupliqué(s). ${
                    sourceLessons.length - lessons.length
                } doublon(s) ignoré(s).`
            );
            this.closeDuplicate();
            await this.loadData();
        } catch (error) {
            toast.error(
                error.response?.data?.msg || "La duplication n’a pas abouti."
            );
        } finally {
            this.setState({ savingDuplicate: false });
        }
    };

    buildDashboard = () => {
        const validDays = new Set(this.state.days.map((day) => String(day.id)));
        const staffById = new Map(
            this.state.staffs.map((staff) => [String(staff.id), staff])
        );
        const workloads = new Map();
        const issues = [];
        const classIssueIds = new Set();
        let totalCourses = 0;
        let validCourses = 0;
        let totalHours = 0;

        this.state.sectionclasses.forEach((sectionclasse) => {
            const lessons = sectionclasse.sectionclasselessons || [];
            const classHours = lessons.reduce(
                (sum, item) => sum + numberValue(item.week_hour),
                0
            );
            totalCourses += lessons.length;
            totalHours += classHours;
            if (classHours > this.state.days.length * HOURS_PER_DAY) {
                classIssueIds.add(String(sectionclasse.id));
                issues.push({
                    key: `class-${sectionclasse.id}`,
                    type: "danger",
                    label: className(sectionclasse),
                    message: `${classHours}h dépassent la capacité de la classe.`,
                });
            }

            lessons.forEach((lesson) => {
                const staffId = lesson.staff?.id || lesson.staffId;
                const staff = staffById.get(String(staffId)) || lesson.staff;
                const hours = numberValue(lesson.week_hour);
                const days = availableDayCount(staff, validDays);
                const complete =
                    Boolean(lesson.lesson?.id) &&
                    Boolean(staffId) &&
                    hours > 0 &&
                    days > 0;
                if (complete) validCourses += 1;
                if (!lesson.lesson?.id || !staffId || hours <= 0) {
                    classIssueIds.add(String(sectionclasse.id));
                    issues.push({
                        key: `lesson-${lesson.id}`,
                        type: "danger",
                        label: `${className(sectionclasse)} · ${
                            lesson.lesson?.entitled_lesson || "Cours incomplet"
                        }`,
                        message: "Cours, titulaire et heures/semaine sont requis.",
                    });
                } else if (!days) {
                    classIssueIds.add(String(sectionclasse.id));
                    issues.push({
                        key: `availability-${lesson.id}`,
                        type: "warning",
                        label: staffName(staff),
                        message: `Aucun jour actif pour ${lesson.lesson?.entitled_lesson}.`,
                    });
                }

                if (staffId) {
                    const workload = workloads.get(String(staffId)) || {
                        staff,
                        hours: 0,
                        courses: 0,
                        days,
                    };
                    workload.hours += hours;
                    workload.courses += 1;
                    workload.days = days;
                    workloads.set(String(staffId), workload);
                }
            });
        });

        workloads.forEach((item, staffId) => {
            const capacity = item.days * HOURS_PER_DAY;
            if (item.hours > capacity) {
                issues.push({
                    key: `staff-${staffId}`,
                    type: "danger",
                    label: staffName(item.staff),
                    message: `${item.hours}h affectées pour ${capacity}h disponibles.`,
                });
                this.state.sectionclasses.forEach((sectionclasse) => {
                    if (
                        (sectionclasse.sectionclasselessons || []).some(
                            (lesson) =>
                                String(lesson.staff?.id || lesson.staffId) ===
                                staffId
                        )
                    )
                        classIssueIds.add(String(sectionclasse.id));
                });
            }
        });

        const completion = totalCourses
            ? Math.round((validCourses / totalCourses) * 100)
            : 0;

        return {
            totalCourses,
            totalHours,
            readiness:
                issues.length === 0 && totalCourses > 0
                    ? 100
                    : Math.min(99, completion),
            issues,
            classIssueIds,
            workloads: [...workloads.values()].sort(
                (left, right) => right.hours - left.hours
            ),
        };
    };

    filteredClasses = (dashboard) => {
        const query = this.state.search.trim().toLowerCase();
        return [...this.state.sectionclasses]
            .filter((item) => {
                const sectionId = String(
                    item.section?.id ||
                        item.sectionId ||
                        item.section?.short_entitled_section
                );
                if (
                    this.state.sectionFilter !== "all" &&
                    sectionId !== this.state.sectionFilter
                )
                    return false;
                if (
                    this.state.readinessFilter === "issues" &&
                    !dashboard.classIssueIds.has(String(item.id))
                )
                    return false;
                if (!query) return true;
                return [
                    className(item),
                    ...(item.sectionclasselessons || []).flatMap((lesson) => [
                        lesson.lesson?.entitled_lesson,
                        staffName(lesson.staff),
                    ]),
                ]
                    .filter(Boolean)
                    .join(" ")
                    .toLowerCase()
                    .includes(query);
            })
            .sort((left, right) =>
                className(left).localeCompare(className(right))
            );
    };

    renderClass = (sectionclasse) => {
        const lessons = [
            ...(sectionclasse.sectionclasselessons || []),
        ].sort(
            (left, right) =>
                (left.lesson?.entitled_lesson || "").localeCompare(
                    right.lesson?.entitled_lesson || ""
                )
        );
        lessons.sort(
            compareLessonsByBulletinOrder
        );
        const hours = lessons.reduce(
            (sum, item) => sum + numberValue(item.week_hour),
            0
        );
        const collapsed = this.state.collapsed[sectionclasse.id];
        const canEdit = this.handleCheck("Modifier cours");
        return (
            <article className="scl-class-card" key={sectionclasse.id}>
                <header className="scl-class-header">
                    <button
                        type="button"
                        className="scl-class-toggle"
                        onClick={() =>
                            this.setState((state) => ({
                                collapsed: {
                                    ...state.collapsed,
                                    [sectionclasse.id]: !collapsed,
                                },
                            }))
                        }
                    >
                        <span className="scl-class-icon">
                            <FeatherIcon icon="book-open" size="19" />
                        </span>
                        <span>
                            <strong>{className(sectionclasse)}</strong>
                            <small>
                                {lessons.length} cours · {hours}h/semaine
                            </small>
                        </span>
                        <FeatherIcon
                            icon={collapsed ? "chevron-down" : "chevron-up"}
                            size="18"
                        />
                    </button>
                    <div className="scl-class-actions">
                        {this.handleCheck("Supprimer cours") && (
                            <button
                                type="button"
                                className="btn btn-light btn-sm"
                                onClick={() => this.openDuplicate(sectionclasse)}
                                title="Dupliquer les affectations"
                            >
                                <FeatherIcon icon="copy" size="16" />
                            </button>
                        )}
                        {this.handleCheck("Ajouter cours") && (
                            <button
                                type="button"
                                className="btn btn-primary btn-sm"
                                onClick={() =>
                                    this.showModal(null, sectionclasse.id)
                                }
                            >
                                <FeatherIcon icon="plus" size="16" /> Cours
                            </button>
                        )}
                    </div>
                </header>
                {!collapsed && (
                    <div className="scl-course-list">
                        {!lessons.length ? (
                            <div className="scl-empty">
                                Aucun cours affecté à cette classe.
                            </div>
                        ) : (
                            lessons.map((lesson) => {
                                const ready =
                                    lesson.staff?.id &&
                                    numberValue(lesson.week_hour) > 0;
                                return (
                                    <button
                                        type="button"
                                        className="scl-course-row"
                                        key={lesson.id}
                                        disabled={!canEdit}
                                        onClick={() =>
                                            this.showModal(
                                                lesson,
                                                sectionclasse.id
                                            )
                                        }
                                    >
                                        <span
                                            className={`scl-status-dot ${
                                                ready
                                                    ? "is-ready"
                                                    : "has-issue"
                                            }`}
                                        />
                                        <span className="scl-course-name">
                                            <strong>
                                                {lesson.lesson
                                                    ?.entitled_lesson ||
                                                    "Cours non renseigné"}
                                            </strong>
                                            <small>
                                                {lesson.domaine?.title ||
                                                    `Ordre bulletin : ${
                                                        lesson.indice || "—"
                                                    }`}
                                            </small>
                                        </span>
                                        <span className="scl-teacher">
                                            {lesson.staff?.user?.avatar ? (
                                                <img
                                                    src={
                                                        lesson.staff.user.avatar
                                                    }
                                                    alt=""
                                                />
                                            ) : (
                                                <span className="scl-avatar">
                                                    <FeatherIcon
                                                        icon="user"
                                                        size="15"
                                                    />
                                                </span>
                                            )}
                                            <span>
                                                {staffName(lesson.staff)}
                                                <small>
                                                    {lesson.staff?.matricule ||
                                                        "Sans matricule"}
                                                </small>
                                            </span>
                                        </span>
                                        <span className="scl-hours">
                                            <strong>
                                                {numberValue(lesson.week_hour)}h
                                            </strong>
                                            <small>par semaine</small>
                                        </span>
                                        <span className="scl-scores">
                                            Éval.{" "}
                                            {numberValue(
                                                lesson.max_evaluation
                                            )}{" "}
                                            · Exam.{" "}
                                            {numberValue(lesson.max_examen)}
                                        </span>
                                        {canEdit && (
                                            <FeatherIcon
                                                icon="edit-2"
                                                size="16"
                                            />
                                        )}
                                    </button>
                                );
                            })
                        )}
                    </div>
                )}
            </article>
        );
    };

    renderPrint = (dashboard) => (
        <div className="scl-print" ref={(node) => (this.componentRef = node)}>
            <Headerpdf />
            <h6 className="text-center">Affectation hebdomadaire des cours</h6>
            <table className="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th>Titulaire</th>
                        <th>Cours</th>
                        <th>Classe</th>
                        <th>H/S</th>
                    </tr>
                </thead>
                <tbody>
                    {dashboard.workloads.flatMap((workload) =>
                        (workload.staff?.sectionclasselessons || []).map(
                            (lesson) => (
                                <tr key={lesson.id}>
                                    <td>{staffName(workload.staff)}</td>
                                    <td>
                                        {lesson.lesson?.entitled_lesson || "—"}
                                    </td>
                                    <td>{className(lesson.sectionclass)}</td>
                                    <td>{numberValue(lesson.week_hour)}h</td>
                                </tr>
                            )
                        )
                    )}
                </tbody>
            </table>
        </div>
    );

    render() {
        const dashboard = this.buildDashboard();
        const classes = this.filteredClasses(dashboard);
        const sections = [
            ...new Map(
                this.state.sectionclasses.map((item) => [
                    String(
                        item.section?.id ||
                            item.sectionId ||
                            item.section?.short_entitled_section
                    ),
                    item.section,
                ])
            ).entries(),
        ];

        return (
            <main className="scl-page">
                <section className="scl-hero">
                    <div>
                        <span className="scl-eyebrow">Préparation de l’horaire</span>
                        <h1>Affectations des cours</h1>
                        <p>
                            Titulaires, volumes horaires et contraintes
                            hebdomadaires réunis avant la génération.
                        </p>
                    </div>
                    <div className="scl-hero-actions">
                        <ReactToPrint
                            trigger={() => (
                                <button type="button" className="btn btn-light">
                                    <FeatherIcon icon="printer" size="17" />{" "}
                                    Imprimer
                                </button>
                            )}
                            content={() => this.componentRef}
                        />
                        {this.handleCheck("Ajouter cours") && (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => this.showModal()}
                            >
                                <FeatherIcon
                                    icon="plus-circle"
                                    size="17"
                                />{" "}
                                Nouvelle affectation
                            </button>
                        )}
                        {this.handleCheck("Afficher horaire") && (
                            <Link className="btn btn-dark" to="/propositions">
                                Générer l’horaire{" "}
                                <FeatherIcon
                                    icon="arrow-right"
                                    size="17"
                                />
                            </Link>
                        )}
                    </div>
                </section>

                {this.state.error && (
                    <div className="alert alert-danger mt-3">
                        {this.state.error}
                    </div>
                )}

                <section className="scl-metrics">
                    <div className="scl-readiness-card">
                        <div
                            className="scl-progress-ring"
                            style={{
                                "--progress": `${dashboard.readiness * 3.6}deg`,
                            }}
                        >
                            <span>{dashboard.readiness}%</span>
                        </div>
                        <div>
                            <small>Préparation</small>
                            <strong>
                                {dashboard.readiness === 100
                                    ? "Prêt pour l’horaire"
                                    : "Données à compléter"}
                            </strong>
                            <span>
                                {dashboard.issues.length} alerte(s) à vérifier
                            </span>
                        </div>
                    </div>
                    {[
                        [
                            "layers",
                            this.state.sectionclasses.length,
                            "Classes",
                        ],
                        ["book", dashboard.totalCourses, "Cours affectés"],
                        [
                            "clock",
                            `${dashboard.totalHours}h`,
                            "Volume hebdomadaire",
                        ],
                        [
                            "users",
                            dashboard.workloads.length,
                            "Enseignants",
                        ],
                    ].map(([icon, value, label]) => (
                        <div className="scl-metric" key={label}>
                            <FeatherIcon icon={icon} />
                            <span>
                                <strong>{value}</strong>
                                {label}
                            </span>
                        </div>
                    ))}
                </section>

                <section className="scl-workspace">
                    <div className="scl-main-column">
                        <div className="scl-toolbar">
                            <label className="scl-search">
                                <FeatherIcon icon="search" size="17" />
                                <input
                                    type="search"
                                    name="search"
                                    value={this.state.search}
                                    onChange={this.handleInput}
                                    placeholder="Classe, cours ou enseignant…"
                                />
                            </label>
                            <select
                                name="sectionFilter"
                                value={this.state.sectionFilter}
                                onChange={this.handleInput}
                                className="form-select form-select-sm"
                            >
                                <option value="all">Toutes les sections</option>
                                {sections.map(([id, section]) => (
                                    <option value={id} key={id}>
                                        {section?.entitled_section ||
                                            section?.short_entitled_section ||
                                            "Section"}
                                    </option>
                                ))}
                            </select>
                            <select
                                name="readinessFilter"
                                value={this.state.readinessFilter}
                                onChange={this.handleInput}
                                className="form-select form-select-sm"
                            >
                                <option value="all">Toutes les classes</option>
                                <option value="issues">
                                    Classes à corriger
                                </option>
                            </select>
                            <span className="scl-result-count">
                                {classes.length} résultat(s)
                            </span>
                        </div>
                        {!this.state.loading ? (
                            <FeatherIcon className="user-search-spin" icon="loader" />
                        ) : classes.length ? (
                            <div className="scl-class-grid">
                                {classes.map(this.renderClass)}
                            </div>
                        ) : (
                            <div className="scl-empty scl-empty-page">
                                <FeatherIcon icon="inbox" size="28" />
                                Aucune classe ne correspond aux filtres.
                            </div>
                        )}
                    </div>

                    <aside className="scl-side-column">
                        <div className="scl-panel">
                            <div className="scl-panel-title">
                                <span>
                                    <FeatherIcon
                                        icon="alert-triangle"
                                        size="17"
                                    />
                                    Contrôles
                                </span>
                                <b>{dashboard.issues.length}</b>
                            </div>
                            {!dashboard.issues.length ? (
                                <div className="scl-success">
                                    <FeatherIcon
                                        icon="check-circle"
                                        size="22"
                                    />
                                    Les affectations sont cohérentes.
                                </div>
                            ) : (
                                <div className="scl-issue-list">
                                    {dashboard.issues
                                        .slice(0, 8)
                                        .map((issue) => (
                                            <div
                                                className={`scl-issue ${issue.type}`}
                                                key={issue.key}
                                            >
                                                <strong>{issue.label}</strong>
                                                <span>{issue.message}</span>
                                            </div>
                                        ))}
                                    {dashboard.issues.length > 8 && (
                                        <small className="text-muted">
                                            + {dashboard.issues.length - 8}{" "}
                                            autre(s) alerte(s)
                                        </small>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="scl-panel">
                            <div className="scl-panel-title">
                                <span>
                                    <FeatherIcon icon="activity" size="17" />
                                    Charge des professeurs
                                </span>
                            </div>
                            <div className="scl-workload-list">
                                {/* {dashboard.workloads.slice(0, 10).map((item) => { */}
                                {dashboard.workloads?.map((item) => {
                                    const capacity =
                                        item.days * HOURS_PER_DAY;
                                    const percentage = capacity
                                        ? Math.min(
                                              100,
                                              Math.round(
                                                  (item.hours / capacity) * 100
                                              )
                                          )
                                        : 100;
                                    return (
                                        <div
                                            className="scl-workload"
                                            key={item.staff?.id}
                                        >
                                            <div>
                                                <strong>
                                                    {staffName(item.staff)}
                                                </strong>
                                                <span>
                                                    {item.hours}h / {capacity}h
                                                </span>
                                            </div>
                                            <div className="progress">
                                                <div
                                                    className={`progress-bar ${
                                                        item.hours > capacity
                                                            ? "bg-danger"
                                                            : ""
                                                    }`}
                                                    style={{
                                                        width: `${percentage}%`,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="scl-panel">
                            <Lesson />
                        </div>
                    </aside>
                </section>

                {this.state.sectionDiplique && (
                    <div className="scl-duplicate-bar">
                        <div>
                            <FeatherIcon icon="copy" size="18" />
                            <span>
                                Dupliquer{" "}
                                <strong>
                                    {className(this.state.sectionDiplique)}
                                </strong>
                            </span>
                        </div>
                        <select
                            name="sectionclasseId"
                            value={this.state.sectionclasseId}
                            onChange={this.handleInput}
                            className="form-select form-select-sm"
                        >
                            {this.state.allClasses
                                .filter(
                                    (item) =>
                                        String(item.id) !==
                                        String(this.state.sectionDiplique.id)
                                )
                                .sort((left, right) =>
                                    className(left).localeCompare(
                                        className(right)
                                    )
                                )
                                .map((item) => (
                                    <option value={item.id} key={item.id}>
                                        {className(item)}
                                    </option>
                                ))}
                        </select>
                        <button
                            type="button"
                            className="btn btn-light btn-sm"
                            onClick={this.closeDuplicate}
                        >
                            Annuler
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={this.duplicateLessons}
                            disabled={this.state.savingDuplicate}
                        >
                            {this.state.savingDuplicate
                                ? "Duplication…"
                                : "Confirmer"}
                        </button>
                    </div>
                )}

                <div className="d-none">{this.renderPrint(dashboard)}</div>
                <SectionclasselessonForm
                    isModal={this.state.isModal}
                    formData={this.state.formData}
                    sectionclasse={this.state.sectionclasse}
                    showModal={this.showModal}
                    staffs={this.state.staffs}
                    lessonsByClass={this.state.sectionclasses}
                    sectionclasses={this.state.allClasses}
                    days={this.state.days}
                />
            </main>
        );
    }
}

export default Sectionclasselesson;
